import React from 'react';
import Nav from './nav';
import { Link } from 'react-router-dom'

const Header = (props) => {
  return (
    <div className="container">
      <header className="is-flex">

        <h1 className="nav-item">
          <Link to="home" title="Home"><strong>{props.name}</strong></Link> <span>| {props.slogan}</span>
        </h1>

        <Nav />
      </header>
    </div>
  )
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/header.js